import { PRODUCT_CONFIG, type ProductConfig } from '../app/product-config/registry'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isNative } from '../lib/platform'
import { SystemBarsBackground as NativeSystemBarsBackground } from '../plugins/systemBarsBackground'

export default function SystemBarsBackground({ config = PRODUCT_CONFIG.humanteq }: { config?: ProductConfig }) {
  const { pathname } = useLocation()

  useEffect(() => {
    if (!isNative) return
    const color = config.sections.some((section) => section.path === pathname) ? config.theme['--bg-primary'] : config.theme['--bg-start']
    NativeSystemBarsBackground.setBackgroundColor({ color }).catch(() => {})
  }, [pathname, config])

  return null
}
